import React from 'react';
import styled from 'styled-components';

import AiIntelligenceForm from './AiIntelligenceForm';
import BookContestForm from './BookContestForm';
import DatahubForm from './DatahubForm';
import DemoForm from './DemoForm';
import DownloadableAssetForm from './DownloadableAssetForm';
import DownloadTemplateForm from './DownloadTemplateForm';
import EdgeForm from './EdgeForm';
import EhsForm from './EhsForm';
import EventsForm from './EventsForm';
import PartnersSignupForm from './PartnersSignupForm';
import RequestPricingForm from './RequestPricingForm';
import StarterSubscriptionForm from './StarterSubscriptionForm';
import TshirtGiveawayForm from './TshirtGiveawayForm';
import TrialForm from './FreeTrialForm';
import NominationForm from './NominationForm';
import HubspotEmbedForm from './HubspotEmbed';

import { color } from '../../atoms/colors';
import { shadow } from '../../atoms/shadows';

const FORM_COMPONENTS = {
  book: BookContestForm,
  'datahub-form': DatahubForm,
  demo: DemoForm,
  download: DownloadTemplateForm,
  'downloadable-asset': DownloadableAssetForm,
  'edge-pricing': EdgeForm,
  event: EventsForm,
  livestorm: EventsForm,
  partners: PartnersSignupForm,
  pricing: RequestPricingForm,
  subscription: StarterSubscriptionForm,
  'tshirt-giveaway': TshirtGiveawayForm,
  trial: TrialForm,
  'nomination-form': NominationForm,
  'ai-intelligence-early-access-form': AiIntelligenceForm,
  'ehs-form': EhsForm,
  'hubspot-embed-form': HubspotEmbedForm,
};

const FormGenerator = ({
  componentProps,
  location,
  theme,
  purchasePlan,
  setShowFormModal,
}) => {
  const Component = FORM_COMPONENTS[componentProps?.variant];

  if (!Component) return null;

  if (componentProps?.variant === 'event') {
    return (
      <Container>
        <Component component={{ eventRegistration: componentProps }} />
      </Container>
    );
  }

  return (
    <Component
      component={componentProps}
      location={location}
      purchasePlan={purchasePlan}
      theme={theme}
      setShowFormModal={setShowFormModal}
    />
  );
};

export default FormGenerator;

const Container = styled.div`
  width: 100%;
  background-color: ${color.common.white};
  ${shadow('xl', 'dark')};
  padding: 32px;
  border-radius: 12px;
`;
